type SchemeDisplaySource = {
  alternateName?: string | null;
  schemeName?: string | null;
  schemeMetaDataName?: string | null;
  scheme?: any;
};

export const getSchemeDisplayName = (
  source?: SchemeDisplaySource | null,
  fallback = null
) =>
  source?.alternateName ||
  source?.schemeName ||
  source?.schemeMetaDataName ||
  source?.scheme ||
  fallback;
